export default __webpack_public_path__ + "static/media/LaboratoryElectronic.f26c5aac.PNG";